import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [hashServidor, setHashServidor] = useState('');

  const [logado, setLogado] = useState(() => localStorage.getItem('logado') === '1');

  const [carregando, setCarregando] = useState(true);

  const SESSION_MINUTES = 30;
  const [expiresAt, setExpiresAt] = useState(() => Number(localStorage.getItem('expiresAt') || 0));
  //const timerRef = useRef(null);
  //const tickRef = useRef(null);

  
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);

  async function sha256Hex(text) {
    const data = new TextEncoder().encode(text);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const bytes = new Uint8Array(hashBuffer);
    return Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('');
  }

  async function handleLogin(e) {
      e.preventDefault();
      setErro('');
      try {
          if (!hashServidor) {
              setErro('Hash não carregado. Verifique /public/senha.txt ou /public/pass.txt');
              return;
          }
          const hashDigitado = await sha256Hex(senha);
          if (hashDigitado === hashServidor) {
              fetch("/api/log_access.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  evento: "acesso liberado",
                  path: window.location.pathname,
                  ts: new Date().toISOString(),
                  userAgent: navigator.userAgent,
                }),
              }).catch(() => {});
              setLogado(true);
              localStorage.setItem('logado', '1');
              const deadline = Date.now() + SESSION_MINUTES * 60 * 1000;
              localStorage.setItem('expiresAt', String(deadline));
              setExpiresAt(deadline);
              //scheduleAutoLogout(deadline);
              //startTick(deadline);
              setSenha('');
              irAgora();
          } else {
            fetch("https://seismicviewer.outerlamce.com/api/log_access.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  evento: "acesso negado - senha incorreta",
                  path: window.location.pathname,
                  ts: new Date().toISOString(),
                  userAgent: navigator.userAgent,
                }),
              }).catch(() => {});
              setErro('Senha incorreta');
          }
      } catch {
          setErro('Erro ao verificar a senha');
      }
  }

  function handleLogout() {
      setLogado(false);
      localStorage.removeItem('logado');
      localStorage.removeItem('expiresAt');
      setExpiresAt(0);
      setSenha('');
  }

  useEffect(() => {
      (async () => {
        try {
          const resp = await fetch('/pass.txt', { cache: 'no-store' });
          if (resp.ok) {
            const txt = (await resp.text()).trim();
            setHashServidor(txt);
          }
        } catch (err) {
          console.error(err);
        }
      })();

      function onStorage(e) {
          if (e.key === 'expiresAt' || e.key === 'logado') {
              const exp = Number(localStorage.getItem('expiresAt') || 0);
              if (localStorage.getItem('logado') !== '1' || !exp || Date.now() > exp) {
                  handleLogout();
              } else {
                  setExpiresAt(exp);
                  //scheduleAutoLogout(exp);
                  //startTick(exp);
              }
          }
      }
      window.addEventListener('storage', onStorage);
      return () => window.removeEventListener('storage', onStorage);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  function cancelarAgendamento() {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
      if (intervalRef.current) clearInterval(intervalRef.current)
      timeoutRef.current = null
      intervalRef.current = null
  }

  function irAgora() {
        cancelarAgendamento()
        navigate('/viewer')
    }

  /*useEffect(() => {
    // carregar senha do arquivo
    (async () => {
      try {
        const resp = await fetch('/pass.txt', { cache: 'no-store' });
        if (resp.ok) {
          const txt = (await resp.text()).trim();
          setHashServidor(txt);
        }
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);*/

  /*const handleLogin = async (e) => {
    e.preventDefault();
    if (!hashServidor) {
      setErro('Hash não carregado.');
      return;
    }
    localStorage.setItem('logado', '1');
    // exemplo de navegação direta
    navigate('/viewer');
  };*/

  return (
    <div
      className="min-h-screen grid"
      style={{
        gridTemplateRows: 'auto 1fr auto',
        backgroundColor: '#1a1a2e',
        textAlign: 'center',
      }}
    >
      <header className="pt-8 px-4 text-white">
        <h1 className="text-2xl md:text-3xl font-extrabold mb-2">
          Bem-vindo ao Visualizador Sísmico 3D do GRVA
        </h1>
        <p className="text-gray-300">Efetue o login para continuar</p>
      </header>

      <main className="grid place-items-center px-4">
        <section
          className="w-full max-w-sm bg-white shadow rounded-2xl p-6 space-y-6"
          aria-labelledby="login-title"
        >
          <h2 id="login-title" className="text-2xl font-semibold">
            Login
          </h2>

          <form onSubmit={handleLogin} className="flex flex-col gap-4 items-center">
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <label htmlFor="password" className="font-medium" style={{
                display: "block",
                width: "320px",
                maxWidth: "100%",
                margin: "0 auto",
                textAlign: "left",
              }}>
                Senha:
              </label>

              <div style={{ display: 'flex', justifyContent: 'center', width: '100%'  }}>
                <div style={{ position: "relative", width: "320px", maxWidth: "100%" }}>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid #ccc',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    width: '320px',
                    maxWidth: '100%',
                    backgroundColor: 'white',
                  }}
                >
                  <input
                    id="password"
                    name="password"
                    type={showPass ? 'text' : 'password'}
                    autoComplete="current-password"
                    required
                    value={senha}
                    onChange={(e) => {
                      setSenha(e.target.value);
                      if(erro) setErro('');
                    }}
                    placeholder="Digite sua senha"
                    style={{
                      flex: '1 1 auto',
                      border: 'none',
                      outline: 'none',
                      paddingLeft: '10px',
                      fontSize: '15px',
                      height: '30px',             // altura fixa
                      lineHeight: '30px',         // igual à altura → alinha texto
                      borderRadius: '10px 0 0 10px',
                    }}
                  />

                  {erro && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: "0",
                        marginTop: "6px",
                        backgroundColor: "#fee2e2",
                        color: "#b91c1c",
                        padding: "6px 10px",
                        borderRadius: "8px",
                        fontSize: "12px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {erro}
                      {/* setinha do balão */}
                      <div
                        style={{
                          position: "absolute",
                          top: "-6px",
                          left: "12px",
                          width: "0",
                          height: "0",
                          borderLeft: "6px solid transparent",
                          borderRight: "6px solid transparent",
                          borderBottom: "6px solid #fee2e2",
                        }}
                      />
                    </div>
                  )}

                  <button
                    type="button"
                    onClick={() => setShowPass(!showPass)}
                    aria-label={showPass ? 'Ocultar senha' : 'Mostrar senha'}
                    style={{
                      border: 'none',
                      background: 'transparent',
                      cursor: 'pointer',
                      height: '40px',             // mesma altura do input
                      width: '44px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {showPass ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                  </button>
                </div>
                </div>
              </div>


            </div>

            {/*erro && <p className="text-sm text-red-600">{erro}</p>*/}

            <button
              type="submit"
              className="w-3/4 bg-blue-600 text-white rounded-xl py-2 hover:bg-blue-700 transition font-semibold"
              style={{ maxWidth: '320px', minWidth: '325px', height: '40px', marginTop: '5px', borderRadius: '10px' }}
            >
              Entrar
            </button>

            {!hashServidor && (
              <p className="text-xs text-amber-600 text-center">
                Atenção: o arquivo <code>senha.txt</code> ou <code>pass.txt</code> não foi encontrado ou está vazio.
              </p>
            )}
          </form>
        </section>
      </main>

      <footer
        className="pb-6 flex justify-center"
        style={{
          position: 'absolute',
          backgroundColor: 'rgba(255, 255, 255, 1)',
          height: '50px',
          width: '130px',
          left: '50%',
          transform: 'translateX(-50%)',
          borderRadius: '8px',
          bottom: '25px',
        }}
      >
        <a
          href="https://grva.lamce.coppe.ufrj.br/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white/85 rounded-lg shadow px-2 py-2"
        >
          <img
            src="LAMCE_WEB.png"
            alt="LAMCE / COPPE / UFRJ"
            style={{ mixBlendMode: 'multiply', height: 44 }}
          />
        </a>
      </footer>
    </div>
  );
};

export default Login;



/*const Login = () => {

    const navigate = useNavigate();

    async function sha256Hex(text) {
        const data = new TextEncoder().encode(text);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const bytes = new Uint8Array(hashBuffer);
        return Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('');
    }

    const [hashServidor, setHashServidor] = useState('');
    const [senha, setSenha] = useState('');
    const [logado, setLogado] = useState(() => localStorage.getItem('logado') === '1');
    const [erro, setErro] = useState('');
    const [carregando, setCarregando] = useState(true);

    const SESSION_MINUTES = 30;
    const [expiresAt, setExpiresAt] = useState(() => Number(localStorage.getItem('expiresAt') || 0));
    //const timerRef = useRef(null);
    //const tickRef = useRef(null);
    const [remainingText, setRemainingText] = useState('');

    const [agendado, setAgendado] = useState(false)
    const [segRestantes, setSegRestantes] = useState(15)

    const timeoutRef = useRef(null)
    const intervalRef = useRef(null)

    useEffect(() => {
        // Tenta carregar senha de /senha.txt e, se falhar, de /pass.txt
        setCarregando(true);
        const tryFiles = ['/pass.txt', '/pass.txt'];
        let done = false;

        (async () => {
            for (const path of tryFiles) {
                try {
                    const resp = await fetch(path, { cache: 'no-store' });
                    if (!resp.ok) throw new Error('not ok');
                    const txt = (await resp.text()).trim();
                    if (txt) {
                        setHashServidor(txt);
                        done = true;
                        break;
                    }
                } catch {
                    // tenta o próximo
                }
            }
            if (!done) setErro('Não foi possível carregar senha.txt ou pass.txt');
            setCarregando(false);
        })();
    }, []);

    useEffect(() => {
        function onStorage(e) {
            if (e.key === 'expiresAt' || e.key === 'logado') {
                const exp = Number(localStorage.getItem('expiresAt') || 0);
                if (localStorage.getItem('logado') !== '1' || !exp || Date.now() > exp) {
                    handleLogout();
                } else {
                    setExpiresAt(exp);
                    //scheduleAutoLogout(exp);
                    //startTick(exp);
                }
            }
        }
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    async function handleLogin(e) {
        e.preventDefault();
        setErro('');
        try {
            if (!hashServidor) {
                setErro('Hash não carregado. Verifique /public/senha.txt ou /public/pass.txt');
                return;
            }
            const hashDigitado = await sha256Hex(senha);
            if (hashDigitado === hashServidor) {
                setLogado(true);
                localStorage.setItem('logado', '1');
                const deadline = Date.now() + SESSION_MINUTES * 60 * 1000;
                localStorage.setItem('expiresAt', String(deadline));
                setExpiresAt(deadline);
                //scheduleAutoLogout(deadline);
                //startTick(deadline);
                setSenha('');
                irAgora();
            } else {
                setErro('Senha incorreta');
            }
        } catch {
            setErro('Erro ao verificar a senha');
        }
    }

    function handleLogout() {
    
        setLogado(false);
        localStorage.removeItem('logado');
        localStorage.removeItem('expiresAt');
        setExpiresAt(0);
        setSenha('');
        setRemainingText('');
    }

    function iniciarContagem(segundos = 1) {
        // limpa qualquer coisa anterior
        cancelarAgendamento();

        setSegRestantes(segundos);
        setAgendado(true);

        // contador visual
        intervalRef.current = setInterval(() => {
            setSegRestantes((s) => {
            if (s <= 1) {
                clearInterval(intervalRef.current)
            }
            return s - 1
            })
        }, 1000)

        // navegação após X segundos
        timeoutRef.current = setTimeout(() => {
            irAgora();
        }, segundos * 1000);
    }

    function cancelarAgendamento() {
        if (timeoutRef.current) clearTimeout(timeoutRef.current)
        if (intervalRef.current) clearInterval(intervalRef.current)
        timeoutRef.current = null
        intervalRef.current = null
        setAgendado(false)
    }

    function irAgora() {
        cancelarAgendamento()
        navigate('/viewer')
    }

    useEffect(() => {
        console.log("logado mudou para ", logado);
        if(logado){
            const exp = Number(localStorage.getItem('expiresAt') || 0);
            if (!exp || Date.now() > exp) {
                handleLogout();
            } else {
                setExpiresAt(exp);
                //scheduleAutoLogout(exp);
                //startTick(exp);
            }
            //irAgora();
        } else {
            cancelarAgendamento();
        }
    }, [logado]);

    // UI
    if (carregando) {
        return (
            <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#2f2f2f' }}>
                <div className="text-white">Carregando...</div>
            </div>
        );
    }

    if (logado) {
        return (
            <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#1a1a2e' }}>
                <div className="w-full max-w-sm bg-white shadow rounded-2xl p-6 space-y-4">
                    <h2 className="text-xl font-semibold">Sessão ativa</h2>
                    <p className="text-sm text-gray-600">Expira em: {remainingText}</p>
                    <button
                        onClick={handleLogout}
                        className="w-full bg-red-500 text-white rounded-xl py-2 hover:bg-red-600 transition"
                    >
                        Sair
                    </button>
                </div>
            </div>
        );
        
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4" style={{ backgroundColor: '#1a1a2e', textAlign: 'center' }}>
            <h1>
                Bem vindo ao Visualizador Sísmico 3D do Grva/LAMCE/COPPE/UFRJ
            </h1>
            <h3>
                Efetue o login para continuar
            </h3>
            <form onSubmit={handleLogin} className="w-full max-w-sm bg-white shadow rounded-2xl p-6 space-y-4">
                <h2 className="text-2xl font-semibold">Login</h2>
                <input
                    type="password"
                    required
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    placeholder="Senha"
                    className="w-full border rounded-xl px-3 py-2 focus:outline-none focus:ring focus:ring-blue-200"
                    style={{ width: '177px', borderRadius: '5px', height: '25px' }}
                />
                
                <center>
                    <button
                        type="submit"
                        className="w-full bg-blue-600 text-white rounded-xl py-2 hover:bg-blue-700 transition"
                        style={{ width: '177px', borderRadius: '5px', height: '35px', marginTop: '10px' }}
                    >
                        Entrar
                    </button>
                </center>
                {erro && <p className="text-sm text-red-600">{erro}</p>}
                {!hashServidor && (
                    <p className="text-xs text-amber-600">
                        Atenção: o arquivo <code>public/senha.txt</code> ou <code>public/pass.txt</code> não foi encontrado ou está vazio.
                    </p>
                )}
            </form>
                <div style={{position: 'absolute', bottom: '20px', left: '50%', transform: 'translateX(-50%)', backgroundColor: "rgba(255, 255, 255, 0.85)", borderRadius: '8px', textAlign: 'center', width: '130px', height: "47px", marginTop: '25px' }}>
                    <a href={"https://grva.lamce.coppe.ufrj.br/"} target="_blank" rel="noopener noreferrer">
                        <img src="logo_lamce.png" alt="Logo LAMCE" style={{mixBlendMode: "multiply", width: '125px', height: "50px", borderRadius: '8px' }} />
                    </a>
                </div>
        </div>
    );
};

export default Login;*/